<template>
<!-- 项目 - 设备预警 -->
  <div class="main-box">
    <div style="margin-top:4vh;"></div>
    <div class="box1">
        <div class="box1-l">
            <div class="box1-l-title">
                周数据统计
            </div>
            <div class="weekInfo" id="weekInfo"></div>
        </div>
        <div class="box1-r">
            <div class="box1-r-title">
                年度数据统计
            </div>
            <div class="yearInfo" id="yearInfo"></div>
        </div>
    </div>
    <div class="box2">
        <div class="head-box">
        <div></div>
        <div class="r-input">
          
    
        <span style="font-size:14px;min-width:14px;display:flex;
    align-items: center;margin-left:10px;margin-right: 5px;">日期</span>
        <div style="width:200px;display:flex;">
            <el-date-picker
         size="small"
            v-model="seachTime"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            @change="timefilter"
            :picker-options="pickerOptions">
        </el-date-picker>
        </div>
        </div>
      </div>
        <div class="cont-box">
   <el-table
      :data="listData"
      style="width: 100%">
      <el-table-column
      type="index"
        label="序号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="happenDate"
        label="发现时间"
        >
      </el-table-column>
      <el-table-column
        prop="priorityName"
        label="隐患分类"
        >
      </el-table-column>
            <el-table-column
        prop="description"
        label="隐患详情"
          >
      </el-table-column>
            <el-table-column
        prop="address"
        label="检查结果"
          >
         <template slot-scope="scope">
                                <span v-if="scope.row.checkResult=='无'" style="color:#1ed76d;">{{'是'||'--'}}</span>
                  <span v-else-if="scope.row.checkStatus=='已处理'" style="color:#E6A23C">{{'是'}}</span>
                  <span v-else style="color:red;">{{'否'||'--'}}</span>
                        </template>
  
      </el-table-column>
        <el-table-column label="操作"
        >
                        <template slot-scope="scope">
                         <el-button @click="toDetail(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
    </el-table>
        </div>
      <div class="fenye-b"></div>
      <div class="fenye">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5,10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination>
      </div>
    </div>
      <!-- <div class="table-box">
          <div class="table-item" v-for="(item,index) in listData" :key="index"> -->
              <!-- <div style="width:15vh;height:14vh;position: relative;display: flex;align-items: center;justify-content: center;">
                  <img :src="item.imagePath" style="max-width:100%;max-height:100%;" />
              </div> -->
              <!-- <div class="table-item-con">
                  <p class="title nowrap">{{item.jpushTitle}}</p>
                  <p class="lable">处理状态：
                      <span style="color:#E6A23C;" v-if="item.processStatus=='0'">待处理</span>
                      <span style="color:#4B7FCD;" v-else>已处理</span>
                  </p>
                  <p class="lable nowrap">发生设备：{{item.equipName}}</p>
                  <p class="lable nowrap">发生时间：{{item.createDate}}</p>
              </div>
              <div class="table-item-con">
                  <p class="lable nowrap">处理人：{{item.userName||'--'}}</p>
                  <p class="lable nowrap">处理方式：{{item.processMode||'--'}}</p>
                  <p class="lable nowrap">处理信息：{{item.msg||'--'}}</p>
              </div>
              <div class="table-item-con">
                  <p class="lable nowrap">项目负责人：{{item.projectEnt.name||'--'}}</p>
                  <p class="lable nowrap">联系方式：{{item.projectEnt.phone||'--'}}</p>
                  <p class="lable nowrap"></p>
              </div>
              <div class="table-item-btn flex-center">
                  <el-button type="text" style="margin-right:1vw;" @click="showInfo(item)">详情</el-button>
                  <el-button v-if="item.processStatus=='0'" type="text" style="color:#000066;" @click="toUpdata(item)">立即处理</el-button>
                  <el-button v-if="item.processStatus=='0'" type="text" style="color:#f00;" @click="cancel(item)">取消预警</el-button>
              </div>
          </div>
          <div v-if="noData" style="width:100%;height:100%;display:flex;justify-content: center;align-content: center;align-items: center;">
              暂无数据
          </div>
      </div> -->
      
      <!-- 新增窗口(处理) -->
      <el-dialog
        title="预警处理"
        :visible.sync="handleVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="500px"
      >
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="处理人">
                <el-input v-model="form.userName" readonly></el-input>
            </el-form-item>
            <el-form-item label="处理方式">
                <el-input type="textarea" v-model="form.processMode"></el-input>
            </el-form-item>
            <el-form-item label="处理信息">
                <el-input type="textarea" v-model="form.msg"></el-input>
            </el-form-item>
            <div style="width:100%;height:8vh;display:flex;justify-content: center;align-content: center;align-items: center;">
                <el-button type="primary" @click="modSubmit" round style="width:80%;">确定提交</el-button>
            </div>
        </el-form>
      </el-dialog>
      <!-- 新增窗口(详情) -->
      <el-dialog
        title="预警详情"
        :visible.sync="infoVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class="scene-dialog"
        class="add-form"
        width="60%"
        style="min-width:900px;"
      >
        <div class="head1">
            <!-- <img :src="info.imagePath" style="width:50%;height:100%;position: relative;" /> -->
            <!-- <div style="width:50%;height:100%;position: relative;display: flex;align-items: center;justify-content: center;">
                  <img :src="info.imagePath" style="max-width:100%;max-height:100%;" />
              </div> -->
            <div style="width:50%;height:100%;position: relative;padding-left:2vh;">
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警类型：<span style="color:#993300;">{{info.jpushTitle}}</span></p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警内容：{{info.jpushMsg}}</p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">发生地点：{{info.equipName}}</p>
                <p style="height: 5vh;display: flex;align-items: center;font-size: 1.6vh;">预警时间：{{info.createDate}}</p>
            </div>
        </div>
        <h1 style="width:100%;padding:1vh;font-size:1.8vh;">处理信息</h1>
        <p style="padding:1vh 0 3vh 10vh;">处理状态：<span style="color:#4B7FCD;" v-if="info.processStatus=='1'">已处理</span><span style="color:#FF6633;" v-else>待处理</span></p>
        <div class="con" style="padding-left:14vh;">
            <el-timeline>
                <el-timeline-item timestamp="预警" placement="top" color="#108ee9" style="color:#000;" >
                    <div style="background:rgba(184, 221, 248, 0.2);padding:2vh;">
                        <p>{{info.jpushMsg}}</p>
                    </div>
                    <p style="position: absolute;top: -30px;left: -150px;width: 120px;color: #999;">{{info.createDate}}</p>
                </el-timeline-item>
                <el-timeline-item timestamp="处理完成" placement="top" v-if="info.status=='0'" color="#108ee9" style="color:#000;" >
                    <div style="background:rgba(184, 221, 248, 0.2);padding:2vh;">
                        <h4>处理人：{{info.userName}}</h4>
                        <p style="margin-top:1vh;">{{info.msg}}</p>
                    </div>
                    <p style="position: absolute;top: -30px;left: -150px;width: 120px;color: #999;">{{info.updateDate}}</p>
                </el-timeline-item>
                <el-timeline-item timestamp="待处理" placement="top" v-else color="#b8ddf8">
                    
                </el-timeline-item>
            </el-timeline>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util';
export default {
    data(){
        return{
            search:{
                type:'',
                status:'',
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            types:[   //事件类型
                {id:'2',name:'环境检测',value:'2'},
                {id:'3',name:'塔吊',value:'3'},
                {id:'4',name:'卸料平台',value:'4'},
                {id:'5',name:'升降机',value:'5'},
                {id:'6',name:'深基坑',value:'6'},
                {id:'7',name:'高支模',value:'7'},
                {id:'8',name:'大体积混凝土',value:'8'},
                {id:'10',name:'设备维保',value:'10'},
                {id:'12',name:'质量安全',value:'12'},
                {id:'1000',name:'进度偏移',value:'1000'},
                {id:'1001',name:'能耗',value:'1001'},
                {id:'1002',name:'工资异常',value:'1002'},
            ],
            statusList:[{label:'待处理',value:'0'},{label:'已处理',value:'1'}],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            seachTime:[],
            listData:[],//列表
            noData:false,//是否有数据
            dialogTitle:'预警详情',//
            handleVisible:false,
            form:{   //预警处理
                id:'',
                userName:'',
                userId:'',
                msg:'',
                processMode:'',
            },
            infoVisible:false,//详情弹出框
            info:{  //详情信息

            },
            typeList:{
                type2:'环境监测',
                type3:'塔吊',
                type4:'卸料平台',
                type5:'升降机',
                type6:'深基坑',
                type7:'高支模',
                type8:'大体积混凝土',
                type10:'设备维保',
                type12:'质量安全',
                type1000:'进度偏移',
                type1001:'能耗',
                type1002:'工资异常',
            }
        }
    },
    mounted(){
        // this.seachTime = util.myTime.getCurWeek()
        this.groupId = util.session.get('groupId')
        // this.getTypeList()
        this.getData()
        this.selectYearWarningNumber()

        this.weekWarningCount()
    },
    methods:{
         toDetail(row){
          // handle:是否从我的里面进去
          this.$router.push({ name: 'qsDetail', params: { id: row.qsId ,type:row.type,handle:'1'} })
        },
        // 获取周数据
   async weekWarningCount(){
    console.log('进入周数据函数===》');
    const data = await myHttp.weekWarningCount({
      projectId:this.groupId
    })
    if (data.data.code==200) {
      let list=data.data.data
  let dataList=[]
  let dateList=[]
for (let index = 0; index < list.length; index++) {
  const element = list[index];
  dateList.push(element.date)
  dataList.push(element.warningCount)
  console.log(element);
}
console.log('日期数组==》',dateList);
console.log('数据数组==》',dataList);
        this.echarts1(dataList,dateList)
    }
  
    console.log(data);
   },
       echarts1(dataA,dateA){
        const that=this
console.log('进入图表函数====》',dataA,dateA);

        let chartDom = document.getElementById('weekInfo');
        let myChart = this.$echarts.init(chartDom);
          myChart.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: function(params){
              console.log(params)
              let result = '<div style="color:#2BC7FB">'+'总数'+dataA[params[0].dataIndex]+'</div>'
                            return result
              // if(params.length>0){
              //   let result = params[0].name + "<br>";
              //   params.forEach(function (item){
              //     //item.value
              //     if (true) {
              //       result +=
              //         item.marker +
              //         " " +
              //         item.seriesName +
              //         " : " +
              //         item.value +'%'+
              //         "</br>";
              //     } else if (item.seriesName == "完成进度") {
              //       result +=
              //         item.marker +
              //         " " +
              //         item.seriesName +
              //         " : " +
              //         item.value +
              //         "%</br>";
              //     }
              //   })
              //       return result;
              // }
            }
          },
          width:'83%',
          // legend: {
          //   orient: 'vertical' ,
          //   data: dateA,
          //   right:'0',
          //   top:'10%'
          // },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          
          color:['#2BABF0'],
          xAxis: {
            axisLine: {
                    lineStyle: {
                      type: 'solid',
                      color: '',
                      width: '1'
                    }
                  },
            type: 'category',
        splitLine:{
                    show: true, //让网格显示
                    lineStyle: {//网格样式
                      color:['#07DBFF'], //网格的颜色
                      width:1, //网格的宽度
                      type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                    }
                  },
            boundaryGap: false,
            data: dateA,
          },
          yAxis: {
            axisLabel:{
              show:true,
              interval:'auto',
              // formatter:'{value}%'
            },
            // min:0,
            // max:100,
           
			scale : true,
            splitNumber : 5,
            type: 'value',
            splitLine:{
              show: true,
              lineStyle: {
                color:['#07DBFF'],
                width:1,
                type:'dashed'
              }
            },
          },
          series: {
              type: 'line',
              data: dataA,
              itemStyle: {
                      normal: {
                        areaStyle: {
                          type: "default",
                          opacity: 0.2
                        },
                      },
                    },
            }
        })
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          myChart.resize();
        });
          myChart.on('click', function (params) {
         console.log('监听到图表被点击===》',params.name);
         that.examTime=params.name
         let time=[params.name,params.name]
         that.seachTime=time
         that.getData()
              
              })
      },
        //年统计图
        echartsYear(itemSt){
            let chartDom = document.getElementById('yearInfo');
            let myChart = this.$echarts.init(chartDom);
            myChart.setOption({
                color:['#0d3a95','#4d7bd8','#8394b5','#34579d'],
                series: [
                    {
                    label: {
              show: true,
              position: "inner",
              formatter: "{b}{d}%",
            },
                    name: 'Nightingale Chart',
                    type: 'pie',
                    radius: [0, 150],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 0
                    },
                    data: itemSt
                    }
                ]
            });
        },
        // 预警年统计
        selectYearWarningNumber(){
            let that = this
            myHttp.quarterWarningCount({
                projectId:util.session.get('groupId'),
                year:util.myTime.getYear()
            }).then(res => {
                console.log(res,'结果')
                if(res.data.code==200){
                    let item = [
                        { value:res.data.data.persentOne, name: '第一季度' },
                        { value:res.data.data.persentTwo, name: '第二季度' },
                        { value:res.data.data.persentThree, name: '第三季度' },
                        { value:res.data.data.persentFour, name: '第四季度' }
                    ]
                    console.log(item)
                    that.echartsYear(item)
                }
            })
        },
        //获取事件类型
        getTypeList(){
            var that = this
            myHttp.getTopicValueList().then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.aiEquipCameraTopics||[];
                    that.types = list;
                }else{
                    that.$message.error(resp.data.msg);
                }
            },function(){});
        },
        //条件过滤
        dofilter(){
            this.getData()
        },
        //时间过滤
        timefilter(){
            this.getData()
            console.log(this.seachTime);
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage=1
            this.getData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        // getData(){
        //     var that = this
        //     myHttp.selectSysJpushMsgAllPage({
        //         projectId:this.groupId,
        //         pageNum:this.currentPage,
        //         pageSize:this.pageSize,
        //         processStatus:this.search.status,
        //         jpushNoticeType:this.search.type,
        //         startTime:this.seachTime[0],
        //         endTime:this.seachTime[1],
        //     }).then(function(resp){
        //       console.log(resp);
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data.pageInfo.list||[]
        //             for(var i=0;i<list.length;i++){
        //                 if(list[i].jpushTitle.includes('力矩')){
        //                     list[i].imagePath = require('../../../assets/image/new/lj.png')
        //                 }else if(list[i].jpushTitle.includes('高度限位')){
        //                     list[i].imagePath = require('../../../assets/image/new/gdxw.png')
        //                 }else if(list[i].jpushTitle.includes('质量安全')){
        //                     list[i].imagePath = require('../../../assets/image/new/zlaq.png')
        //                 }else if(list[i].jpushTitle.includes('塔吊黑匣子')){
        //                     list[i].imagePath = require('../../../assets/image/new/hxz.png')
        //                 }else if(list[i].jpushTitle.includes('扬尘')){
        //                     list[i].imagePath = require('../../../assets/image/new/yc.png')
        //                 }else if(list[i].jpushTitle.includes('压力')){
        //                     list[i].imagePath = require('../../../assets/image/new/yl.png')
        //                 }
        //             }
        //             that.listData = list
        //             that.totalItems = resp.data.data.pageInfo.total||0
        //             if(list.length==0){
        //                 that.noData = true
        //             }else{
        //                 that.noData = false
        //             }
        //         }else{
        //             that.noData = true
        //         }
        //     })
        // },
        async  getData(){
          console.log(this.seachTime);
            if(this.seachTime && this.seachTime.length>0){

            var starTime=this.seachTime[0]
            var endTime=this.seachTime[1]
            }else{
                   var starTime=''
            var endTime=''
            }
          const data=await myHttp.selectQsListByProjectIdPageNew({
          
            projectId: this.groupId,
starTime: starTime,
endTime:endTime ,
form: 1,
type: '',
dispose: 3,
pageNum: this.currentPage,
pageSize: this.pageSize
          })
          if (data.data.code==200) {
            console.log(data.data.data.qsList.list);
            this.listData=data.data.data.qsList.list
            this.totalItems=data.data.data.qsList.total
           
            
          }
          console.log('数据列表===》',data);
        },

        //处理弹出框
        toUpdata(row){
            this.form.id = row.id
            this.form.userName = util.session.get('user').name
            this.form.userId = util.session.get('user').id
            this.form.msg = ''
            this.form.processMode = ''
            this.handleVisible = true
        },
        //处理
        modSubmit(){
            var that = this
            myHttp.processingWarning(this.form).then(function(resp){
                if(resp.data.code=='200'){
                    that.handleVisible = false
                    that.getData()
                    that.$message.success('处理成功');
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },
        // 取消预警
        cancel(row){
          var that = this
            this.$confirm('此操作将永久取消预警, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
            myHttp
                .deleteSysJpushMsgAll({
                id: row.id
                })
                .then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message({
                    type: 'success',
                    message: '取消成功!'
                    })
                    that.getData()
                } else {
                    that.$message.error(resp.data.msg)
                }
                })
            })
            .catch(err => {})
        },
        //展示内容
        showInfo(row){
            //var that = this
            this.info = row
            this.infoVisible = true
        },
    }
}
</script>

<style scoped>
    .main-box{
        width: 100%;
        height: 100%;
        position: relative;
        /* padding: 1vw; */
        background: #ECF0F5;
        overflow: auto;
        padding-left: 8px;
        padding-right: 24px;
    }
    .head-box{
        width: 100%;
        height: 6vh;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        border-bottom: 2px solid #E7E7E7;
        padding-left: 1vw;
    }
    .head-box *{
        /* margin-right: 1vw; */
        font-family: SourceHanSansCN-Regular;
font-size: 18px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 14vh );
        position: relative;
        padding: 1vh 0;
        overflow: auto;
    }
    .table-item{
        width: 100%;
        height: 16vh;
        padding: 2vh 2vh 0;
        position: relative;
        border-bottom: 1px solid #F2F2F2;
        display: flex;
    }
    .table-item-con{
        width: calc( 33% - 7vh );
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding-left: 4vw;
    }
    .table-item-btn{
        width: 20vh;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .table-item-con .title{
        width: 100%;
        height: 4vh;
        color: #993300;
        font-size: 1vw;
        position: relative;
        line-height: 4vh;
    }
    .table-item-con .lable{
        width: 100%;
        height: 3vh;
        position: relative;
    }
    .table-item-con p{
        text-align: left;
    }
    .flex-center{
        display: flex;
        justify-content: center;
        justify-items: center;
    }

    /* .scene-dialog{
        width:100
    } */
    .scene-dialog .head1{
        width: 100%;
        height: 27vh;
        padding: 0 1vh;
        margin-bottom: 3vh;
        position: relative;
        display: flex;
    }
    .box1{
        margin-top: 26px;
        height: 41vh;
        display: flex;
    }
    .box1-l{
        width: 62vw;
        height: 100%;
        border-radius: 6px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
    }
    .box1-l-title{
        height: 6vh;
        display: flex;
        justify-content: start;
        align-items: center;
        padding-left: 18px;
        border-bottom: 2px solid #E7E7E7;
        font-family: SourceHanSansCN-Regular;
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 0em;
        color: #666666;
    }
    .box1-r{
        flex: 1;
        margin-left: 8px;
        border-radius: 6px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
    }
    .box1-r-title{
        height: 6vh;
        display: flex;
        justify-content: start;
        align-items: center;
        padding-left: 18px;
        border-bottom: 2px solid #E7E7E7;
        font-family: SourceHanSansCN-Regular;
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 0em;
        color: #666666;
    }
    .box2{
        position: relative;
        margin-top: 8px;
        margin-bottom: 10px;
        height: 81.5vh;
        border-radius: 6px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
    }
    .cont-box{
        height: 67vh;
        margin-top: 1.5vh;
        overflow: auto;
        padding: 0 0.43vw;
        
    }
    .cont-box-item{
        height: 15.8vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgb(77 110 177 / 30%);
    margin-bottom: 1.1vh;
    padding: 0 0.85vw 0 1.09vw;
    display: flex;
    align-items: center;
    }
    .item1{
        width: 6vw;
        height:  6vw;
    }
    .item2{
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;
        text-align: start;
        margin-left: 2.7vw;
        width: 24vw;
    }
    .item2-title{
        font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #D21B1B;
    }
    .item2-lab{
            color: #9E9E9E;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    }
    .item3{
        padding-top: 5.3vh;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;
        text-align: start;
        width: 20vw;
    }
    .item3-lab{
        color: #9E9E9E;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em
    }
    .item4{
        padding-top: 5.28vh;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;
        text-align: start;
        width: 20vw;
    }
    .item4-lab{
        color: #9E9E9E;
        font-family: SourceHanSansCN-Regular;
        font-size: 18px;
        font-weight: normal;
        letter-spacing: 0em;
    }
    .item5{
        padding-top: 1.29vh;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        margin-left: 5vw;
    }
    .btn{
        width: 3.3vw;
    height: 3.2vh;
    border-radius: 6px;
    background: #FDFEFE;
    box-sizing: border-box;
    border: 1px solid rgba(153, 153, 153, 0.8);
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1vh;
    }
    .btn:hover{
        cursor: pointer;
        opacity: 0.7;
    }
    .fenye-b{
        height: 6vh;
        position: absolute;
        left: 0;bottom: 0;
    }
    .fenye{
        width: 100%;
        position: absolute;
        left: 0;bottom: 0;
        border-radius: 0px 0px 6px 6px;
        background: #FFFFFF;
        box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
    }
    .red{
        color: #D21B1B !important;
    }
    .lv{
        color: #10B33B !important;
    }
    .yearInfo{
        width: 25.38vw;
        height: 38vh;
    }
    .weekInfo{
        width: 61.92vw;
        height: 38vh;
    }
    .r-input{
      float: right;
      margin-right: 0.5521vw;
        width: 39vw;
        display: flex;
  justify-content: end;
    }
</style>
<style>
    @import '../../../assets/css/common.css'
</style>